// This file requires the following components:
// - rentals-form

class RentalsFormTrigger extends HTMLElement {
  constructor() {
    super();

    if (!this.form) return;

    this.addEventListener('click', () => {
      // trick to wait for the backdrop to be added to the DOM
      setTimeout(() => {
        this.form.formInputs[0].dropdown.show();
      });
    });
  }

  get form() {
    return document.querySelector(this.getAttribute('data-target')) || this.closest('rentals-form');
  }
}

customElements.define('rentals-form-trigger', RentalsFormTrigger);
